import { message } from 'antd';
import { kevinAuthAPI } from 'apis/config';
import { handleMessage } from 'utils/helper/message';

export const scriptAPI = {
  getScript: (project_id: number, episode_id: number, lang: string) =>
    kevinAuthAPI
      .get(`/story/${project_id}/script/${episode_id}?lang=${lang}`)
      .then((res) => res.data.script)
      .catch((error) => {
        console.log(error);
      }),
  saveScript: (project_id: number, episode_id: number, lang: string, data) =>
    kevinAuthAPI
      .post(`/story/${project_id}/script/${episode_id}?lang=${lang}`, data)
      .then((res) => res.data)
      .catch((err) => {
        console.log(err.response.data);
        handleMessage(message, 'error', err.response.data.message);
      }),
  getScriptResourceLists: (project_id: number) =>
    kevinAuthAPI
      .get(`/common/script/resources/${project_id}`)
      .then((res) => res.data),

  getTemplateList: (lang: string) =>
    kevinAuthAPI.get(`/common/script/template`).then((res) => res.data),
  getInEffectList: (lang: string) =>
    kevinAuthAPI.get(`/common/in_effect`).then((res) => res.data),
  getOutEffectList: (lang: string) =>
    kevinAuthAPI.get(`/common/out_effect`).then((res) => res.data),

  getSpeakerList: (project_id: number) =>
    kevinAuthAPI
      .get(`/common/script/speaker/${project_id}`)
      .then((res) => res.data),
  getSpeakerMotionList: (project_id: number) =>
    kevinAuthAPI
      .get(`/common/script/motion/${project_id}`)
      .then((res) => res.data),
  getSpeakerEmoticonList: (project_id: number) =>
    kevinAuthAPI
      .get(`/common/script/emoticon/${project_id}`)
      .then((res) => res.data),
};
